module.exports = __webpack_public_path__ + "media/images/illust/blog-304ae1a1d76dcf029db90cf6f361816a.jpg";